import Tabs from '@/shared/components/Tabs/Tabs'
import { useFloorPlanStore } from '../../store/useFloorPlanStore'
import styles from './RoomSwitcher.module.scss'

/**
 * Room (sala) tabs shown above the planner. Room management (add / rename /
 * delete) lives in the editor panel, this component is just the tab switcher.
 */
function RoomSwitcher() {
  const rooms = useFloorPlanStore(s => s.rooms)
  const activeRoomId = useFloorPlanStore(s => s.activeRoomId)
  const setActiveRoom = useFloorPlanStore(s => s.setActiveRoom)

  const sortedRooms = [...rooms].sort((a, b) => a.order - b.order)
  const tabs = sortedRooms.map(room => ({ label: room.name, value: room.id }))

  return (
    <div className={styles.switcher} id="tour-floor-plan-rooms">
      {activeRoomId && (
        <Tabs
          tabs={tabs}
          value={activeRoomId}
          onChange={value => setActiveRoom(String(value))}
        />
      )}
    </div>
  )
}

export default RoomSwitcher
